import React, { useState } from "react";
import "./ContactUs.css";

export default function ContactUs() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.placeholder === "Full Name"
        ? "name"
        : e.target.placeholder === "Your Email"
        ? "email"
        : e.target.placeholder === "Number"
        ? "number"
        : "message"]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxDYFxhqAKJ-zFhtrN9IRnv9aWp23i1iCsOo-L7KFej8a32URnLFztdVq_fREzSVuQm/exec";

    try {
      const response = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.result === "success") {
        alert("Message Sent Successfully!");
        setFormData({
          name: "",
          email: "",
          number: "",
          message: ""
        });
      }
    } catch (error) {
      alert("Something went wrong!");
      console.error(error);
    }
  };

  return (
    <section className="contact-section section-space pt-lg-5 pb-lg-4">
      <div className="container">
        <div className="row contact-row">

          {/* Contact Info (Left) */}
         <div className="col-lg-4 col-md-12 mb-4">

  {/* Phone */}
  <div className="info-card shadow-sm">
    <div className="icon-circle">
      <i className="fa-solid fa-phone"></i>
    </div>

    <div className="info-content">
      <p>
        <a href="tel:+919418094125">+91 9418094125</a>
      </p>

      <p>
        <a href="tel:+917018172074">+91 7018172074</a>
      </p>

      <p>
        <a href="tel:+918580593956">+91 8580593956</a>
      </p>
    </div>
  </div>

  {/* Email */}
  <div className="info-card shadow-sm">
    <div className="icon-circle">
      <i className="fa-solid fa-envelope"></i>
    </div>

    <div className="info-content">
      <p>
        <a href="mailto:mehartours@gmail.com">
          mehartours@gmail.com
        </a>
      </p>
    </div>
  </div>

  {/* Location */}
  <div className="info-card shadow-sm">
    <div className="icon-circle" style={{width:"110px"}}>
      <i className="fa-solid fa-location-dot"></i>
    </div>

    <div className="info-content">
      <p>
        <a
          href="https://www.google.com/maps/dir/31.0933349,77.1349612/Jamuna+Bhawan,+Chakkar+-+Boileauganj+Bypass+Rd,+Sandal+Estate,+Lower+Chakkar,+Chakkar,+Shimla,+Himachal+Pradesh+171005/@31.0916544,77.1328445,17z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3905793d20bd7e8d:0x734e6170c2ecbee6!2m2!1d77.1358879!2d31.0916914?entry=ttu&g_ep=EgoyMDI2MDYyOS4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
         Jamuna Bhawan,Lower Chakkar,Shimla Himachal Pradesh 171005
        </a>
      </p>
    </div>
  </div>

</div>

          {/* Contact Form (Right) */}
          <div className="col-lg-8 col-md-12 mb-4">
            <div className="contact-form-card shadow-sm">
              <h1>Contact Us</h1>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Full Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  placeholder="Your Email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  placeholder="Number"
                  required
                  value={formData.number}
                  onChange={handleChange}
                />
                <textarea
                  placeholder="Your Message"
                  rows="6"
                  required
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                <button type="submit">Send Message</button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}